import script from "./ScheduledPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduledPatient.vue?vue&type=script&setup=true&lang=js"

import "./ScheduledPatient.vue?vue&type=style&index=0&id=7c4bcc62&lang=css"

const __exports__ = script;

export default __exports__